import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateScopes } from '@cloud-twin-v2/cloud-twin-shared/core/translate-scopes';
import { ElementTypeCategoriesDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { BaseCalculateResizableChildComponent } from '@common-modules/shared/core/responsive/base-calculate-resizable-child.component';
import { IElementSize } from '@common-modules/shared/model/element-size';
import { popupWrapperExtraHeight } from '@common-modules/shared/wrappers/popup-wrapper/popup-wrapper.component';
import { ChartType } from '@common-modules/wlm-charts/core/models/chart-type.enum';
import { TrendChartSettings } from '@common-modules/wlm-charts/core/models/trend-chart-settings';
import { Observable, of } from 'rxjs';

const COMPONENT_SELECTOR = 'tc-profile-chart-popup';
@Component({
    selector: COMPONENT_SELECTOR,
    templateUrl: './profile-chart-popup.component.html',
    styleUrls: ['./profile-chart-popup.component.scss'],
    standalone: false
})
export class ProfileChartPopupComponent
  extends BaseCalculateResizableChildComponent
  implements OnInit
{
  T_SCOPE = `${TranslateScopes.MasterOperator}.${COMPONENT_SELECTOR}`;
  profileChartConfiguration: ProfileChartPopupConfiguration;
  chartSettings: TrendChartSettings;
  load = false;
  dimensionToCalculate: 'height' | 'width' = 'height';
  private readonly _extraMarginsHeight = popupWrapperExtraHeight;

  constructor(
    private dialogRef: MatDialogRef<ProfileChartPopupComponent>,
    @Inject(MAT_DIALOG_DATA) parameters: ProfileChartPopupConfiguration
  ) {
    super();
    this.profileChartConfiguration = parameters;
  }

  ngOnInit(): void {
    this.popuplateCharts();
    this.listenSelfContainerSize();
  }

  popuplateCharts(): void {
    this.chartSettings = {
      dataParameters: {
        dataService: 'ProfileChartService',
        startDate: this.profileChartConfiguration.startDate,
        endDate: this.profileChartConfiguration.startDate,
        queryParams: this.profileChartConfiguration,
      },
      chartType: ChartType.trend,
    };
  }

  cancel() {
    this.dialogRef.close(false);
  }

  fixedSizes$(): Observable<IElementSize>[] {
    return [
      of({
        height: this._extraMarginsHeight,
        width: null,
      }),
    ];
  }
}

export class ProfileChartPopupConfiguration {
  startDate: Date;
  profileId: string;
  scenarioId: string;
  attributesMetadata: ElementTypeCategoriesDto[];
  name: string;

  constructor(init: Partial<ProfileChartPopupConfiguration>) {
    Object.assign(this, init);
  }
}
